export enum STATE_LIST {
  PLAYLIST = 'playlist',
  PROJECT = 'project',
  PITCHED = 'PITCHED',
  REQUESTED = 'requested',
  QUOTED = 'quoted',
  LICENSED = 'licensed',
  INVOICED = 'invoiced',
  DONE = 'done',
  DELETED = 'DELETED',
}

export enum TypeAddEnum {
  msr = 'MSR',
  psr = 'PSR',
  mlr = 'MLR',
  mcr = 'MCR',
  playlist = 'PLAYLIST',
  project = 'PROJECT',
  request = 'REQUEST',
  system = 'SYSTEM',
}

export enum TypeRequestEnum {
  msr = 'MSR',
  psr = 'PSR',
  mlr = 'MLR',
  mcr = 'MCR',
}

export enum ProjectSort {
  ALPHA = 'ALPHA',
  DATE = 'UPDATED_TIME',
}

export enum Restriction {
  OPEN = 'OPEN',
  RESTRICTED = 'RESTRICTED',
  INVISIBLE = 'INVISIBLE',
}
